import { Component, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { FormGroupState } from 'ngrx-forms'
import { Observable, of } from 'rxjs'
import { DebitCharge, selectPaymentMethodsState } from '../../user-payment-methods.state'
import { EditPage } from '../../../../utils/services/can-deactivate-guard.service'
import { CreateDebitChargeRequest, HttpService } from '@api/http.service'
import { CustomerInformationState, selectProfileState } from '../../../user-profile/user-profile.state'
import { catchError, first, tap } from 'rxjs/operators'
import { Subscriptions } from '../../../../utils/subscriptions'
import { NGXLogger } from 'ngx-logger'
import { ActivatedRoute, Router } from '@angular/router'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ErrorSnackBarComponent } from '../../../../utils/components/error-snack-bar/error-snack-bar.component'
import { CustomerInfoActions } from '../../../user-profile/user-profile.actions'
import { environment } from 'src/environments/environment'
import { SnackBarData } from '../../../../utils/components/error-snack-bar/data'

@Component({
  selector: 'cover-new-debit-charge',
  templateUrl: './new-debit-charge.component.html',
  styleUrls: ['./new-debit-charge.component.scss'],
})
export class NewDebitChargeComponent extends EditPage implements OnDestroy {
  environment = environment
  formState$: Observable<FormGroupState<Omit<DebitCharge, 'mandateReference'>>>
  c4SessionId = ''
  address: CustomerInformationState | undefined
  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  constructor(
    private readonly store: Store,
    private readonly http: HttpService,
    private readonly logger: NGXLogger,
    private readonly snackbar: MatSnackBar,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {
    super()
    this.formState$ = this.store.select(selectPaymentMethodsState.newDebitChargeControls)
    this.subscriptions.plusOne = store
      .select(selectProfileState.c4SessionId)
      .pipe(
        tap(sessionId => {
          this.c4SessionId = sessionId
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = store
      .select(selectProfileState.customerInformationState)
      .pipe(
        tap(address => {
          this.address = address
        }),
      )
      .subscribe()
  }

  submitDebitCharge(formState: FormGroupState<Omit<DebitCharge, 'mandateReference'>>): void {
    this.pending = true
    this.http
      .createDebitCharge({
        sessionId: this.c4SessionId,
        iban: formState.controls.iban.value,
        bic: formState.controls.bic.value,
        accountOwner: formState.controls.owner.value,
        bankName: formState.controls.bank.value,
        checkbox: formState.controls.sepaAgreement.value && formState.controls.sepaConditions.value,
      } as CreateDebitChargeRequest)
      .pipe(
        first(),
        tap(response => {
          this.pending = false
          if (response.parameter.RESPONSE_OK !== -1) {
            this.store.dispatch(CustomerInfoActions.paymentMethodsLoad({ payload: { sessionId: this.c4SessionId } }))
            this.router.navigate(['../../'], { relativeTo: this.route })
          } else {
            this.snackbar.openFromComponent(ErrorSnackBarComponent, {
              duration: 5000,
              panelClass: ['error-snack-bar'],
              data: {
                text: response.parameter.RESPONSE_ERROR,
              } as SnackBarData,
            })
          }
        }),
        catchError(error => {
          this.pending = false
          this.snackbar.openFromComponent(ErrorSnackBarComponent, {
            duration: 5000,
            panelClass: ['error-snack-bar'],
            data: {
              title: 'ERROR.SEPA_CREATION',
            } as SnackBarData,
          })
          return of(error)
        }),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
